// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__hRzCm","layoutContent":"Layout_layoutContent__US9Ll"};